import React, { useState } from "react";
import "./index.css";
import ImageModal from "../cropper/ImageModal";
import { Link } from "react-router-dom";
import { getTrans as T } from '../../../../../Shared/Language';



const ImageInput = ({
  imageDataDemo,
  imageData,
  name,
  onChange,
  showPreview,
  defaultPic,
}) => {
  const [imagePic, setCropedImage] = useState(imageDataDemo)
  const [image, setImage] = useState(imageData);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [height, setHeight] = useState(null);
  const [width, setWidth] = useState(null);
  const onChangeHandler = file => {
     onChange({
      [name]: {
        data: file[0],
        src: URL.createObjectURL(file[0]),
      },
    });

    image.push({
      count: 13,
      image: URL.createObjectURL(file[0])
    })
    setImage(image)
  };



  const handleFile = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files;
      var url = URL.createObjectURL(file[0]);
      var img = new Image();
      img.src = url;
      
      img.onload = function () {
        setWidth(this.width);
        setHeight(this.height);
      };
      const maxAllowedSize = 5 * 1024 * 1024;
      if (file[0].size > maxAllowedSize) {
      } else {
        setCropedImage(file[0])
        setModalIsOpen(true);
      }
      e.target.value = null;
    }
  };
  let inputElement;

  return (
    <div className=" gallery-popupdiv" >

      <ImageModal
        modalIsOpen={modalIsOpen}
        closeModal={() => {
          setModalIsOpen(prevState => !prevState);
        }}
        image={imagePic}
        onCropImage={croppedImg => onChangeHandler([croppedImg])}
        ratio={height / width <= 0.5 ? true : false}
      />

      <div className="container-fluid">
        <div className="form-head d-flex flex-wrap align-items-center">
          <div className="me-auto">
            <h2 className="font-w600 mb-0">Single Album</h2>
            <p className="text-light">Lorem ipsum  dolor sit amet </p>

          </div>
          <input type="file" name="" ref={input => (inputElement = input)} accept="image/*" style={{ "visibility": "hidden", display: "none" }} onChange={handleFile} />
          <button className="add-btncss gal-a me-2" onClick={() => inputElement.click()}><i aria-hidden="true" className="fa fa-upload me-2" ></i>Upload image</button>
          <Link to="Gallery" className="btn btn-primary gal-a"><i aria-hidden="true" className="fa fa-angle-left me-2"></i>Back</Link>


        </div>
        <div className="popup">

          <div className="top-bar">
            <p className="image-name" style={{ "visibility": "hidden" }}>img1.png</p>
            <span className=""><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x close-btn ml-auto" viewBox="0 0 16 16">
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg></span>
          </div>

          <button className="arrow-btn left-arrow"><img src="https://github.com/kunaal438/image-popup/blob/master/img/arrow.png?raw=true" alt="" /></button>
          <button className="arrow-btn right-arrow"><img src="https://github.com/kunaal438/image-popup/blob/master/img/arrow.png?raw=true" alt="" /></button>
          <div className="row">
            <div className="col-lg-8 p-0">
              <img src="images/gallery/1.jpg" className="large-image w-100 h-100 mt-0" alt="" />
            </div>
            <div className="col-lg-4 p-0">
              <div className="bg-white w-100 d-block commhight">
                <div className="user-info">
                  <a >Single Album Category</a>
                  <span className="time">July 26 2018, 01:03pm</span>
                  <p className="gallery-para">Reference site about Lorem Ipsum, giving informaon its origins, as well as a random Lipsum generato</p>
                  <div className="inner-content d-flex" style={{ "marginLeft": "auto" }}>
                    <p className="m-0 mb-0 pside" style={{ "display": "-webkit-box" }}>
                      <i className="fa fa-heart-o heart-fa"></i>

                      &#128151;<a href="" className="hearta" data-bs-toggle="modal" data-bs-target="#likes-list">12 Likes</a>

                    </p>

                    <p className="pside">
                      <a href="">23 {T('Comments')}</a>
                    </p>

                  </div>

                  <div className="mt-3 comment-div">
                    <strong>{T('Comments')}</strong>
                    <div className="commentsec">
                      <textarea className="form-control me-2" rows="1" cols="1"></textarea><button className="add-btncss"><i className="fa fa-angle-right" aria-hidden="true"></i></button></div>
                    <div className="card is-post">
                      <div className="content-wrap">
                        <div className="card-heading" style={{ "alignItems": "inherit" }}>
                          <div className="user-block">
                            <div className="image w-auto">
                              <img src="images/main-body/user1.jpg" data-demo-src="assets/img/avatars/elise.jpg" data-user-popover="6" alt="" />
                            </div>
                            <div className="user-info">
                              <a >Elise Walker</a>
                              <span className="time">July 19 2018, 19:42pm</span>
                              <p className="m-0">Reference site about Lorem Ipsum, giving information on its origins, as well as a random Lipsum generator.</p>
                              <ul className="d-flex">
                                <li className="pr-3">Like</li>
                                <li>Reply</li>
                              </ul>

                            </div>
                          </div>

                        </div>

                        <div className="card-heading" style={{ "alignItems": "inherit" }}>
                          <div className="user-block">
                            <div className="image w-auto">
                              <img src="images/main-body/user1.jpg" data-demo-src="assets/img/avatars/elise.jpg" data-user-popover="6" alt="" />
                            </div>
                            <div className="user-info">
                              <a >Elise Walker</a>
                              <span className="time">July 19 2018, 19:42pm</span>
                              <p className="m-0">Reference site about Lorem Ipsum, giving information on its origins, as well as a random Lipsum generator.</p>
                              <ul className="d-flex">
                                <li className="pr-3">Like</li>
                                <li>Reply</li>
                              </ul>

                            </div>
                          </div>

                        </div>

                        <div className="card-heading" style={{ "alignItems": "inherit" }}>
                          <div className="user-block">
                            <div className="image w-auto">
                              <img src="images/main-body/user1.jpg" data-demo-src="assets/img/avatars/elise.jpg" data-user-popover="6" alt="" />
                            </div>
                            <div className="user-info">
                              <a >Elise Walker</a>
                              <span className="time">July 19 2018, 19:42pm</span>
                              <p className="m-0">Reference site about Lorem Ipsum, giving information on its origins, as well as a random Lipsum generator.</p>
                              <ul className="d-flex">
                                <li className="pr-3">Like</li>
                                <li>Reply</li>
                              </ul>

                            </div>
                          </div>

                        </div>

                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h1 className="index">01</h1>
          </div>
        </div>


        <div className="gallery">

          {
            image.map((newImage, key) => {
              return (<div className="gallery-image" key={key}>
                <button className="play-button" >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
                  </svg>
                </button>
                <div id="myDIV">
                  <a  data-bs-toggle="modal" data-bs-target="#report-img">Report A Picture</a>
                </div>
                <img src={newImage.image} alt="" className="image" />
                <div className="overlay-layer">
                  <div className="overlay-content">
                    <div className="inner-content d-flex" style={{ "marginLeft": "auto" }}>
                      <p className="mr-4 mb-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-heart-fill mr-3" viewBox="0 0 16 16">
                          <path fillRule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"></path>
                        </svg>12
                      </p>
                      <p className="mb-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chat-dots-fill mr-3" viewBox="0 0 16 16">
                          <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"></path>
                        </svg>5
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              )
            })}

          {/* <div className="gallery-image">
            <button className="play-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
              </svg>
            </button>
            {showPreview && (
          <img key={imageData} src={imageData ? imageData : defaultPic} className='image' alt="" onError={e => (e.target.src = defaultPic)} />
         )}
            <div className="overlay-layer">
              <div className="overlay-content">
                <div className="inner-content d-flex" style={{ "marginLeft": "auto" }}>
                  <p className="mr-4 mb-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-heart-fill mr-3" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"></path>
                    </svg>12
                  </p>
                  <p className="mb-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chat-dots-fill mr-3" viewBox="0 0 16 16">
                      <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"></path>
                    </svg>5
                  </p>
                </div>
              </div>
            </div>
          </div> */}

        </div>
      </div>
    </div>
  );
};

export default ImageInput;
